import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "rounded-lg shadow-lg border border-gray-300 max-w-full" }
const _hoisted_2 = {
  id: "titulo",
  class: "text-2xl text-center text-primary-900 font-bold p-4 pb-0"
}
const _hoisted_3 = { class: "p-4 pt-0" }




export default /*@__PURE__*/_defineComponent({
  ...{ name: 'GenericCard' },
  __name: 'GenericCard',
  props: {
  title: { type: String, required: true },
  className: { type: String, required: false },
},
  setup(__props) {



const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex flex-col items-center", props.className])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(props.title), 1),
      _cache[0] || (_cache[0] = _createElementVNode("hr", { class: "my-4 border-gray-200" }, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ])
  ], 2))
}
}

})